import React from 'react';
import CaseStudyLayout from '../../../components/caseStudy/index';
import { Kingpin1, Kingpin2, Kingpin3, Kingpin4, Kingpin5, Kingpin6 } from '../image_index';
import { sections } from './config';

const Kingpin = () => {
    return (
        <CaseStudyLayout
            title='Kingpin'
            link='https://moreminttea.github.io/kingpin/#/'
            subtitle='Interactive Worldbuilding & Lore Platform'
            heroImage={[Kingpin1, Kingpin2, Kingpin3, Kingpin4, Kingpin5, Kingpin6]}
            duration='2022, 2025 - Present'
            tools='React, TypeScript, SCSS, Figma, Adobe'
            team='Beverly Fan, Mindy Mohr'
            role='UI/UX Designer, Frontend Engineer, Artist'
            summary={(
                <p>
                    Kingpin is an interactive, media-rich web application built to bring a multi-layered fantasy universe to life through immersive UI/UX design and high-performance frontend architecture.
                    The site serves as an interactive atlas and archive—combining heavy world data and rich character profiles into a seamless single-page application.
                </p>
            )}
            sections={sections}
        />
    );
}

export default Kingpin;